import { defineMessages } from 'react-intl';

import { Cryptocurrency } from '@sorare/core/src/__generated__/globalTypes';
import type { RefineListProps } from '@sorare/core/src/components/search/RefineList';
import { cryptocurrencySymbols } from '@sorare/core/src/lib/cryptocurrency';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { glossary } from '@sorare/core/src/lib/glossary';

import {
  makeBackendFilter,
  makeFilter,
} from '#src/searchCards/RefineList/index.tsx';

const optionsForActiveFilters = defineMessages({
  eth: {
    defaultMessage: 'ETH accepted',
  },
  sol: {
    defaultMessage: 'SOL accepted',
  },
  cash: {
    defaultMessage: 'Cash accepted',
  },
});

export const getFormatSettlementWallets: (
  forActiveFilters: boolean
) => NonNullable<RefineListProps['formatOption']> = (
  forActiveFilters: boolean
) => {
  const formatSettlementWallets: NonNullable<
    RefineListProps['formatOption']
  > = (option, formatMessage) => {
    switch (option) {
      case 'eth':
        return forActiveFilters
          ? formatMessage(optionsForActiveFilters.eth)
          : cryptocurrencySymbols[Cryptocurrency.WEI];
      case 'fiat':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
      case 'sol':
        return forActiveFilters
          ? formatMessage(optionsForActiveFilters.sol)
          : cryptocurrencySymbols[Cryptocurrency.LAMPORT];
      default:
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
    }
  };
  return formatSettlementWallets;
};

export const RefineSettlementWallets = makeFilter(FILTERS.settlementWallets, {
  searchable: false,
  formatOption: getFormatSettlementWallets(false),
  sortBy: ['name:desc'],
});

export const RefineBackendSettlementWallets = makeBackendFilter(
  FILTERS.settlementWallets,
  {
    searchable: false,
    formatOption: getFormatSettlementWallets(false),
    sortBy: ['name:desc'],
  }
);
